import ReactGA from 'react-ga4';

// Send a custom event
const GtagEvent = (action, action_creator, action_value) => {
  ReactGA.event({
    category: 'logs',
    action: action,
    label: 'user_tracking', // optional
    value: action_value, // optional, must be a number
  });
};

export default GtagEvent;
